// @ts-nocheck

import { AppActionTypes } from '../types/actions/app';

/**
 * FIXME
 * [description]
 * @param  {[type]} options.scope    [description]
 * @param  {[type]} options.severity [description]
 * @param  {[type]} options.message  [description]
 * @param  {[type]} options.type     [description]
 * @return {[type]}                  [description]
 */
const addMessage = ({ scope, severity, message, type }) => ({
  type: AppActionTypes.ADD_FLASH_MESSAGE,
  payload: {
    scope,
    severity,
    message,
    type,
  },
});

/**
 * FIXME
 * [description]
 * @param  {[type]} options.scope [description]
 * @param  {[type]} options.id    [description]
 * @return {[type]}               [description]
 */
export const delMessage = ({ scope, id }) => ({
  type: AppActionTypes.DEL_FLASH_MESSAGE,
  payload: {
    scope,
    id,
  },
});

/**
 * FIXME
 * [description]
 * @param  {[type]} options.scope [description]
 * @return {[type]}               [description]
 */
const clearScope = ({ scope }) => ({
  type: AppActionTypes.CLEAR_SCOPE_FLASH_MESSAGE,
  payload: {
    scope,
  },
});

export default {
  addMessage,
  delMessage,
  clearScope,
};
